exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* stylelint-disable */\n\n/* ==========================================================================\n   Flex\n   ========================================================================== */\n.flex {\n  display: flex;\n  flex-wrap: wrap; }\n\n.flex > * {\n  min-width: 0;\n  max-width: 100%; }\n\n/* Margins\n   ========================================================================== */\n.flex--margin-medium {\n  margin-top: 20px; }\n  .flex--margin-medium:last-child {\n    margin-bottom: 20px; }\n\n/* Direction\n   ========================================================================== */\n.flex--direction-row {\n  flex-direction: row; }\n\n.flex--direction-column {\n  flex-direction: column; }\n\n.flex--direction-row-reverse {\n  flex-direction: row-reverse; }\n\n.flex--direction-column-reverse {\n  flex-direction: column-reverse; }\n\n/* Justify content\n   ========================================================================== */\n.flex--justify-flex-start {\n  justify-content: flex-start; }\n\n.flex--justify-center {\n  justify-content: center; }\n\n.flex--justify-flex-end {\n  justify-content: flex-end; }\n\n.flex--justify-space-between {\n  justify-content: space-between; }\n\n.flex--justify-space-around {\n  justify-content: space-around; }\n\n/* Align items\n   ========================================================================== */\n.flex--align-flex-start {\n  align-items: flex-start; }\n\n.flex--align-center {\n  align-items: center; }\n\n.flex--align-flex-end {\n  align-items: flex-end; }\n\n.flex--align-baseline {\n  align-items: baseline; }\n\n.flex--align-stretch {\n  align-items: stretch; }\n\n/* Align self\n   ========================================================================== */\n.flex--align-self-flex-start {\n  align-self: flex-start; }\n\n.flex--align-self-center {\n  align-self: center; }\n\n.flex--align-self-flex-end {\n  align-self: flex-end; }\n\n.flex--align-self-baseline {\n  align-self: baseline; }\n\n.flex--align-self-stretch {\n  align-self: stretch; }\n\n/* Wrap\n   ========================================================================== */\n.flex--flex-wrap-wrap {\n  flex-wrap: wrap; }\n\n.flex--flex-wrap-nowrap {\n  flex-wrap: nowrap; }\n\n/* Backgrounds\n   ========================================================================== */\n.flex--background-light {\n  background-color: #f8f8f8; }\n\n.flex--background-white {\n  background-color: #fff; }\n\n/* Gutters\n   ========================================================================== */\n.flex--gutter-xx-small {\n  padding-left: 2.5px;\n  padding-right: 2.5px; }\n  .flex--gutter-xx-small.flex--expanded {\n    margin-left: -5px;\n    margin-right: -5px; }\n\n.flex--gutter-x-small {\n  padding-left: 5px;\n  padding-right: 5px; }\n  .flex--gutter-x-small.flex--expanded {\n    margin-left: -10px;\n    margin-right: -10px; }\n\n.flex--gutter-small {\n  padding-left: 7.5px;\n  padding-right: 7.5px; }\n  .flex--gutter-small.flex--expanded {\n    margin-left: -15px;\n    margin-right: -15px; }\n\n.flex--gutter-medium {\n  padding-left: 10px;\n  padding-right: 10px; }\n  .flex--gutter-medium.flex--expanded {\n    margin-left: -20px;\n    margin-right: -20px; }\n\n.flex--gutter-large {\n  padding-left: 15px;\n  padding-right: 15px; }\n  .flex--gutter-large.flex--expanded {\n    margin-left: -30px;\n    margin-right: -30px; }\n\n.flex--gutter-x-large {\n  padding-left: 20px;\n  padding-right: 20px; }\n  .flex--gutter-x-large.flex--expanded {\n    margin-left: -40px;\n    margin-right: -40px; }\n\n.flex--gutter-xx-large {\n  padding-left: 30px;\n  padding-right: 30px; }\n  .flex--gutter-xx-large.flex--expanded {\n    margin-left: -60px;\n    margin-right: -60px; }\n", ""]);

// exports
exports.locals = {
	"color-groups": "base | colors | primary | semantic | chart",
	"colors-white": "#fff",
	"colors-red": "#f54545",
	"colors-green": "#6acb4c",
	"colors-body-color": "#363636",
	"colors-grey-90": "#444",
	"colors-grey-80": "#666",
	"colors-grey-70": "#858484",
	"colors-grey-60": "#a4a4a4",
	"colors-grey-50": "#c2c2c2",
	"colors-grey-40": "#ddd",
	"colors-grey-30": "#ececec",
	"colors-grey-20": "#f2f2f2",
	"colors-grey-10": "#f8f8f8",
	"colors-black": "#000",
	"base-brown-100": "#343230",
	"base-brown-80": "#474340",
	"base-brown-60": "#61554c",
	"base-brown-40": "#998673",
	"base-brown-20": "#c1aa95",
	"base-earth-100": "#bbb6af",
	"base-earth-80": "#c7c1b8",
	"base-earth-60": "#d7cebf",
	"base-earth-40": "#eae4db",
	"base-earth-20": "#e9e7db",
	"base-earth-10": "#f7f5eb",
	"primary-romantic-purple-base": "#834ba2",
	"primary-romantic-purple-dark": "#5a3770",
	"primary-romantic-purple-light": "#ab83c4",
	"primary-sky-blue-base": "#25b8d2",
	"primary-sky-blue-dark": "#1797ae",
	"primary-sky-blue-light": "#57d0dd",
	"primary-mint-base": "#3fc798",
	"primary-mint-dark": "#2cab7f",
	"primary-mint-light": "#79dbb5",
	"primary-grassy-base": "#96cb4c",
	"primary-grassy-dark": "#81a03c",
	"primary-grassy-light": "#b7dd7a",
	"primary-desert-sunset-base": "#eca03e",
	"primary-desert-sunset-dark": "#c2802a",
	"primary-desert-sunset-light": "#fbc75c",
	"primary-salmon-base": "#f57b45",
	"primary-salmon-dark": "#d45e2a",
	"primary-salmon-light": "#ef9a78",
	"semantic-color-primary": "#f57b45",
	"semantic-color-primary-hovered": "#d45e2a",
	"semantic-color-primary-active": "#ef9a78",
	"semantic-color-secondary": "#25b8d2",
	"semantic-color-secondary-hovered": "#1797ae",
	"semantic-color-secondary-active": "#57d0dd",
	"semantic-color-light": "#fff",
	"semantic-color-light-hovered": "#fff",
	"semantic-color-light-active": "#fff",
	"semantic-color-dark": "#f8f8f8",
	"semantic-color-dark-hovered": "#f2f2f2",
	"semantic-color-dark-active": "#f8f8f8",
	"semantic-color-error": "#f54545",
	"semantic-color-success": "#6acb4c",
	"semantic-color-warning": "#eca03e",
	"semantic-color-instruction": "#25b8d2",
	"semantic-color-info": "#834ba2",
	"semantic-color-hint": "#c2c2c2",
	"chart-first": "#25b8d2",
	"chart-second": "#f57b45",
	"chart-third": "#96cb4c",
	"chart-fourth": "#eca03e",
	"chart-fifth": "#3fc798",
	"chart-sixth": "#ab83c4",
	"chart-seventh": "#c1aa95",
	"chart-eighth": "#c2c2c2"
};